import { extendTheme } from '@mui/joy/styles';

export const theme = extendTheme({
  colorSchemes: {
    dark: {
      palette: {
        primary: {
          50: '#eff6ff',
          100: '#dbeafe',
          200: '#bfdbfe',
          300: '#93c5fd',
          400: '#60a5fa',
          500: '#2E5BBA',
          600: '#2563eb',
          700: '#1d4ed8',
          800: '#1e40af',
          900: '#1B365D',
        },
        success: {
          50: '#ecfdf5',
          100: '#d1fae5',
          200: '#a7f3d0',
          300: '#6ee7b7',
          400: '#34d399',
          500: '#00A86B',
          600: '#059669',
          700: '#047857',
          800: '#065f46',
          900: '#064e3b',
        },
        warning: {
          50: '#fffbeb',
          100: '#fef3c7',
          200: '#fde68a',
          300: '#fcd34d',
          400: '#fbbf24',
          500: '#F59E0B',
          600: '#d97706',
          700: '#b45309',
          800: '#92400e',
          900: '#78350f',
        },
        neutral: {
          50: '#f8fafc',
          100: '#f1f5f9',
          200: '#e2e8f0',
          300: '#cbd5e1',
          400: '#94a3b8',
          500: '#64748b',
          600: '#475569',
          700: '#334155',
          800: '#1e293b',
          900: '#0f172a',
        },
        background: {
          body: '#000000',
          surface: 'rgba(2, 6, 23, 0.9)',
        },
        text: {
          primary: '#ffffff',
          secondary: '#e2e8f0',
        }
      },
    },
  },
  fontFamily: {
    body: "'Maven Pro', 'Inter', sans-serif",
    display: "'Maven Pro', 'Inter', sans-serif",
  },
  typography: {
    h1: {
      fontSize: '3.5rem',
      fontWeight: 700,
      lineHeight: 1.2,
      background: 'linear-gradient(135deg, #1B365D 0%, #2E5BBA 50%, #00A86B 100%)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      backgroundClip: 'text',
    },
    h2: {
      fontSize: '2.5rem',
      fontWeight: 600,
      lineHeight: 1.3,
    },
    h3: {
      fontSize: '2rem',
      fontWeight: 600,
      lineHeight: 1.4,
    },
    body1: {
      fontSize: '1.125rem',
      lineHeight: 1.6,
    },
  },
  components: {
    JoyButton: {
      styleOverrides: {
        root: ({ theme, ownerState }) => ({
          ...(ownerState.variant === 'solid' && ownerState.color === 'primary' && {
            background: 'linear-gradient(135deg, #1B365D 0%, #2E5BBA 100%)',
            '&:hover': {
              background: 'linear-gradient(135deg, #152d4f 0%, #2651a3 100%)',
            },
          }),
          ...(ownerState.variant === 'outlined' && ownerState.color === 'primary' && {
            border: '2px solid transparent',
            background: 'linear-gradient(#0F172A, #0F172A) padding-box, linear-gradient(135deg, #1B365D, #2E5BBA) border-box',
            color: '#2E5BBA',
            '&:hover': {
              background: 'linear-gradient(rgba(27, 54, 93, 0.1), rgba(27, 54, 93, 0.1)) padding-box, linear-gradient(135deg, #1B365D, #2E5BBA) border-box',
            },
          }),
        }),
      },
    },
    JoyCard: {
      styleOverrides: {
        root: {
          background: 'rgba(2, 6, 23, 0.8)',
          backdropFilter: 'blur(20px)',
          border: '1px solid rgba(100, 116, 139, 0.4)',
        },
      },
    },
  },
});